import axios from 'axios';

import { API_BASE } from '../constants';


function getResultsByPdfText(url, qs, isSearchPdfOnly , keyword ) {
    return axios.get(`${url}${qs[0]}=${isSearchPdfOnly}&${qs[1]}=${keyword}`)
 }

 
function getFilters(url) {
   return axios.get(url)
}


function getDecisions( ) {
   return axios.get(`${API_BASE}decisions`)
}


export const searchService = {
    getFilters,
    getResultsByPdfText,
    getDecisions,
};